import { render, staticRenderFns } from "./SavedImageList.vue?vue&type=template&id=1a574464&"
import script from "./SavedImageList.vue?vue&type=script&lang=js&"
export * from "./SavedImageList.vue?vue&type=script&lang=js&"
import style0 from "./SavedImageList.vue?vue&type=style&index=0&id=1a574464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports